import React from "react";
import styles from "./HowItWorks.module.scss";
import HowItWorksUnderline from "images/homepage/HowItWorksUnderline.png";
import Step1Img from "images/homepage/Step1.png";
import Step2Img from "images/homepage/Step2.png";
import Step3Img from "images/homepage/Step3.png";
import Step4Img from "images/homepage/Step4.png";

const steps = [
    { number: 1, image: Step1Img, title: "Buy a game", description: "One purchase, yours forever!" },
    { number: 2, image: Step2Img, title: "Fire up the TV", description: "Open the game with any browser", imagePadding: { paddingLeft: 0 } },
    { number: 3, image: Step4Img, title: "Everyone joins", description: "Use your mobile phone as the controller - no apps required" },
    { number: 4, image: Step3Img, title: "Play instantly", description: "The host starts the game", imagePadding: { paddingRight: 0 } },
];

const HowItWorks = ({ className }) => {
    return (
        <section className={`${styles.howItWorksSection} ${className || ''}`}>
            <div className={styles.sectionLabel}>
                <span className={styles.labelText}>HOW IT WORKS</span>
                <img src={HowItWorksUnderline} alt="" className={styles.labelUnderline} />
            </div>
            <div className={styles.sectionHeading}>
                So simple,<br />even your Grandad can do it!
            </div>
            <p className={styles.sectionSubtitle}>Buy once. Play instantly. No subscriptions.</p>
            <div className={styles.stepsRow}>
                {steps.map(step => (
                    <div key={step.number} className={styles.stepCard}>
                        <div className={styles.stepImageWrap} style={step.imagePadding || {}}>
                            <img src={step.image} alt={step.title} className={styles.stepImage} />
                        </div>
                        <span className={styles.stepNumber}>{step.number}</span>
                        <div className={styles.stepTitle}>{step.title}</div>
                        <p className={styles.stepDescription}>{step.description}</p>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default HowItWorks;
